function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import fetch from 'unfetch';
import { logger } from '@immediate_media/logger';
import Cookies from 'js-cookie';
import { getTokenProperty } from './utils';
import { LOGIN_FLAG_COOKIE_NAME } from './constants';
export var getIsLoggedIn = function getIsLoggedIn() {
  return Cookies.get(LOGIN_FLAG_COOKIE_NAME) === '1';
};

/**
 * @typedef {{
 *  email: string;
 *  idToken: string;
 *  idp: string;
 *  role: string | string[] | null;
 *  userId: string;
 *  vanityId: string | string[];
 * }} UserInfo
 *
 * @typedef {keyof UserInfo} Field
 *
 * @typedef {Omit<UserInfo, 'idToken' | 'userId' | 'vanityId'> & {
 *  sub: string;
 *  vanity_id: string | string[];
 * }} ClaimType
 *
 * @typedef {keyof ClaimType} Claim
 */

/**
 * Normalise the vanity id claim in the access token.
 *
 * There's an unusual issue in the Identity data where a few thousand users
 * have multiple vanity ID claims. Here just pick one (the sort being to
 * make it deterministic).
 *
 * @param {ClaimType['vanity_id']} vanityId
 * @returns {string}
 */
export var normaliseVanityId = function normaliseVanityId(vanityId) {
  if (Array.isArray(vanityId)) {
    return vanityId.sort()[0];
  }
  return vanityId;
};

/**
 * Get user info from the server. The `fields` argument is required and the endpoint will return
 * only the values corresponding to those fields.
 * @template {Field} [TField]
 * @param {TField | TField[]} fields The fields to fetch provided as a string or array of strings.
 * @returns {Promise<
 *  TField extends Field
 *    ? Record<TField, UserInfo[TField]>
 *    : null
 *  | null
 * >} The user info.
 */
export var getUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fields) {
    var data, fieldsArray, params, response, status, statusText, failedFields;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (fields) {
            _context.next = 2;
            break;
          }
          throw new Error('The `fields` argument is required to fetch user info.');
        case 2:
          _context.prev = 2;
          fieldsArray = Array.isArray(fields) ? fields : [fields];
          params = new URLSearchParams(fieldsArray.map(function (field) {
            return ['fields', field];
          }));
          _context.next = 7;
          return fetch("/auth/user-info?".concat(params.toString()));
        case 7:
          response = _context.sent;
          if (response.ok) {
            _context.next = 12;
            break;
          }
          status = response.status, statusText = response.statusText;
          logger.error("Failed to fetch user info. ".concat(status, " - ").concat(statusText));
          return _context.abrupt("return", null);
        case 12:
          _context.next = 14;
          return response.json();
        case 14:
          data = _context.sent;
          failedFields = fieldsArray.filter(function (field) {
            var _data;
            // Skip `role` since `null` is a valid return value for that field.
            if (field === 'role') {
              return false;
            }
            return !((_data = data) !== null && _data !== void 0 && _data[field]);
          });
          if (!failedFields.length) {
            _context.next = 19;
            break;
          }
          logger.error("Failed to fetch user info. Missing fields: ".concat(failedFields.join(', '), "."));
          return _context.abrupt("return", null);
        case 19:
          _context.next = 25;
          break;
        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](2);
          logger.error("Failed to fetch user info. ".concat(_context.t0.message), _context.t0);
          return _context.abrupt("return", null);
        case 25:
          return _context.abrupt("return", data);
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 21]]);
  }));
  return function getUserInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Get a specific user claim from the access token.
 * @template {Claim} TClaim
 * @param {TClaim} claim
 * @param {string} [accessToken] - The access token (server-side only).
 * @returns {Promise<ClaimType[TClaim] | undefined>}
 */
var getUserClaim = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(claim, accessToken) {
    var claimFromToken, isLoggedIn, field, userInfo;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!accessToken) {
            _context2.next = 4;
            break;
          }
          if (typeof window !== 'undefined') {
            logger.warn("E49860: Access token used client-side for claim: \"".concat(claim, "\"."), {
              path: window.location.pathname,
              trace: new Error().stack
            });
          }
          claimFromToken = getTokenProperty(accessToken, claim);
          return _context2.abrupt("return", claimFromToken);
        case 4:
          isLoggedIn = getIsLoggedIn();
          if (isLoggedIn) {
            _context2.next = 7;
            break;
          }
          return _context2.abrupt("return", undefined);
        case 7:
          field = {
            sub: 'userId',
            vanity_id: 'vanityId'
          }[claim] || claim;
          _context2.next = 10;
          return getUserInfo(field);
        case 10:
          userInfo = _context2.sent;
          return _context2.abrupt("return", userInfo === null || userInfo === void 0 ? void 0 : userInfo[field]);
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUserClaim(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Get the user GUID.
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var getUserGuid = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(accessToken) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", getUserClaim('sub', accessToken));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getUserGuid(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Get the user vanity ID.
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var getUserVanityId = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(accessToken) {
    var value;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return getUserClaim('vanity_id', accessToken);
        case 2:
          value = _context4.sent;
          return _context4.abrupt("return", normaliseVanityId(value));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getUserVanityId(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Get the identity provider (i.e. login method).
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var getUserLoginMethod = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(accessToken) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", getUserClaim('idp', accessToken));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUserLoginMethod(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Get the user role.
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var getUserRole = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(accessToken) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", getUserClaim('role', accessToken));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function getUserRole(_x7) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Get the user email.
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var getUserEmail = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(accessToken) {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", getUserClaim('email', accessToken));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function getUserEmail(_x8) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Check if the user has the admin role.
 * @param {string} [accessToken] - The access token (server-side only).
 */
export var isUserAdmin = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(accessToken) {
    var adminRoles;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return getUserRole(accessToken);
        case 2:
          adminRoles = _context8.sent;
          if (adminRoles) {
            _context8.next = 5;
            break;
          }
          return _context8.abrupt("return", false);
        case 5:
          if (!Array.isArray(adminRoles)) {
            adminRoles = [adminRoles];
          }
          return _context8.abrupt("return", adminRoles.some(function (role) {
            return role.includes('wp-admin');
          }));
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function isUserAdmin(_x9) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Should the API client authenticate?
 * @param {'never' | 'always' | 'admin'} authType The authentication type.
 * @param {string} [accessToken] - The access token (server-side only)
 */
export var shouldAuthenticateUser = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(authType, accessToken) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.t0 = authType;
          _context9.next = _context9.t0 === 'never' ? 3 : _context9.t0 === 'always' ? 4 : _context9.t0 === 'admin' ? 5 : 6;
          break;
        case 3:
          return _context9.abrupt("return", false);
        case 4:
          return _context9.abrupt("return", true);
        case 5:
          return _context9.abrupt("return", isUserAdmin(accessToken));
        case 6:
          throw new Error("Unknown auth type: ".concat(authType));
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function shouldAuthenticateUser(_x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();